import { render, staticRenderFns } from "./PremiumInfoBadge.vue?vue&type=template&id=2abcad30&"
import script from "./PremiumInfoBadge.vue?vue&type=script&lang=js&"
export * from "./PremiumInfoBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports